import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { getSellingPriceByDomain, useFormatPrice } from 'hooks/formatting/useFormatPrice';
import useTranslation from 'next-translate/useTranslation';
import { TescomaClubIcon } from 'public/svg/IconsSvg';
import { memo } from 'react';
import { twJoin } from 'tailwind-merge';
import { ProductPricesType, ProductPriceType } from 'types/price';

type ClubPriceInfoProps = {
    price: ProductPriceType;
    prices: ProductPricesType;
    isVatAndTransportInfoRequired: boolean;
};

export const ClubPriceInfo = memo<ClubPriceInfoProps>(({ price, prices, isVatAndTransportInfoRequired = false }) => {
    const { t } = useTranslation();
    const domainConfig = useDomainConfig();
    const { formatPriceObject } = useFormatPrice();

    if (
        prices.tescoma &&
        getSellingPriceByDomain(prices.tescoma, domainConfig) < getSellingPriceByDomain(price, domainConfig)
    ) {
        return (
            <small
                className={twJoin(
                    'block text-small text-red',
                    isVatAndTransportInfoRequired && 'w-full vl:ml-0 vl:block',
                )}
            >
                {`${t('Price for members')} `}
                {formatPriceObject(prices.tescoma)}
                <TescomaClubIcon className="-mt-1 ml-1 h-4 w-4 text-red" />
            </small>
        );
    }

    return null;
});

ClubPriceInfo.displayName = 'ClubPriceInfo';
